import { useCommon } from '../providers';
import { PERMISSIONS, Roles, SCOPES } from '../state/model';

export function usePermissions(scopes?: SCOPES[], roleApp?: Roles) {
  const { role } = useCommon();
  const roleToCheck = roleApp || role;
  const permissions = roleToCheck
    ? PERMISSIONS[roleToCheck]
    : PERMISSIONS[Roles.User];

  const hasPermission = (scopes: SCOPES[]) => {
    const scopesMap: { [key: string]: boolean } = {};
    if (scopes) {
      scopes.forEach((scope: string) => {
        scopesMap[scope] = true;
      });

      return permissions.some((permission) => scopesMap[permission]);
    } else {
      return false;
    }
  };

  const permissionGranted = scopes ? hasPermission(scopes) : false;

  return {
    permissionGranted,
    hasPermission,
  };
}
